
import { GlassCard } from '../../../components/base/FuturisticElements';
import { useTheme } from '../../../contexts/ThemeContext';

export function StatsSection() {
  const { isDark } = useTheme();
  
  const stats = [
    {
      number: '5.5M+',
      label: 'UK SMEs',
      description: 'Small and medium enterprises we aim to protect'
    },
    {
      number: '99.9%',
      label: 'Threat Detection', 
      description: 'Accuracy rate for phishing and smishing attacks'
    },
    {
      number: '24/7',
      label: 'Real-Time Protection',
      description: 'Continuous monitoring across all devices'
    },
    {
      number: '< 1 sec',
      label: 'Response Time',
      description: 'Instant threat alerts and blocking'
    }
  ];

  return (
    <section id="stats" className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className={`text-4xl md:text-5xl font-light mb-6 leading-tight transition-colors duration-300 ${
            isDark ? 'text-white' : 'text-black'
          }`}>
            Building the Future of UK SME <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Cybersecurity</span>
          </h2>
          <p className={`text-xl max-w-3xl mx-auto leading-relaxed font-light transition-colors duration-300 ${
            isDark ? 'text-gray-400' : 'text-gray-400'
          }`}>
            Currently developing next-generation AI cybersecurity solutions for UK small and medium enterprises. Join our beta program to be among the first.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {stats.map((stat, index) => (
            <GlassCard 
              key={index}
              className="text-center group hover:scale-105 transition-transform duration-300"
            >
              <div className="text-3xl md:text-4xl font-light bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-4">
                {stat.number}
              </div>
              <h3 className={`text-lg font-medium mb-3 transition-colors duration-300 ${
                isDark ? 'text-white' : 'text-black'
              }`}>
                {stat.label}
              </h3>
              <p className={`text-sm leading-relaxed font-light transition-colors duration-300 ${
                isDark ? 'text-gray-400' : 'text-gray-400'
              }`}>
                {stat.description}
              </p>
            </GlassCard>
          ))}
        </div>

        <div className="text-center mt-16">
          <GlassCard className="max-w-4xl mx-auto">
            <h3 className={`text-2xl font-light mb-6 transition-colors duration-300 ${
              isDark ? 'text-white' : 'text-black'
            }`}>
              Why UK SMEs Choose Driscop
            </h3>
            <div className="grid md:grid-cols-3 gap-6 text-left">
              <div className="flex items-start gap-3">
                <i className="ri-money-pound-circle-line text-2xl text-blue-400 flex-shrink-0 mt-1"></i>
                <div>
                  <h4 className={`font-medium mb-1 transition-colors duration-300 ${
                    isDark ? 'text-white' : 'text-black'
                  }`}>Affordable Pricing</h4>
                  <p className={`text-sm font-light transition-colors duration-300 ${
                    isDark ? 'text-gray-400' : 'text-gray-400'
                  }`}>Subscription-based model accessible to businesses of all sizes</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-user-settings-line text-2xl text-blue-400 flex-shrink-0 mt-1"></i>
                <div>
                  <h4 className={`font-medium mb-1 transition-colors duration-300 ${
                    isDark ? 'text-white' : 'text-black'
                  }`}>Non-Technical Design</h4>
                  <p className={`text-sm font-light transition-colors duration-300 ${
                    isDark ? 'text-gray-400' : 'text-gray-400'
                  }`}>Tailored for users without IT expertise or dedicated security teams</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-2-line text-2xl text-blue-400 flex-shrink-0 mt-1"></i>
                <div>
                  <h4 className={`font-medium mb-1 transition-colors duration-300 ${
                    isDark ? 'text-white' : 'text-black'
                  }`}>UK-Focused Intelligence</h4>
                  <p className={`text-sm font-light transition-colors duration-300 ${
                    isDark ? 'text-gray-400' : 'text-gray-400'
                  }`}>AI trained on regional attack patterns and local threat data</p>
                </div>
              </div>
            </div>
          </GlassCard>
        </div>
      </div>
    </section>
  );
}
